import { render } from "./FontScaling.vue?vue&type=template&id=6e7e9d64&scoped=true"
import script from "./FontScaling.vue?vue&type=script&lang=js"
export * from "./FontScaling.vue?vue&type=script&lang=js"

import "./FontScaling.vue?vue&type=style&index=0&id=6e7e9d64&lang=scss&scoped=true"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7e9d64"]])

export default __exports__